module.exports = __webpack_public_path__ + "static/media/renato.ee2aa971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/renato.png
// module id = 1155
// module chunks = 0